var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "审核通知公告",
        visible: _vm.dialogVisible,
        width: "70%",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        closed: _vm.handleClose,
      },
    },
    [
      _c("div", { staticClass: "audit-content" }, [
        _c("div", { staticClass: "section" }, [
          _c("div", { staticClass: "section-title" }, [_vm._v("通知类型")]),
          _c(
            "div",
            { staticClass: "section-content" },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "120px", size: "small" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-form-item", { attrs: { label: "消息盒子" } }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.currentRow.msgBox === 1 ? "是" : "否"
                                )
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-form-item", { attrs: { label: "push通知" } }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.currentRow.isPushNotice === 1
                                    ? "是"
                                    : "否"
                                )
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-form-item", { attrs: { label: "短信通知" } }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.currentRow.isSmsNotice === 1 ? "是" : "否"
                                )
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.currentRow.isPushNotice === 1
                    ? _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "push模板ID" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentRow.pushTemplateId || "-"
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.currentRow.isSmsNotice === 1
                    ? _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "短信模板ID" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentRow.smsTemplateId || "-"
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm.currentRow.msgBox === 1
          ? _c("div", { staticClass: "section" }, [
              _c("div", { staticClass: "section-title" }, [
                _vm._v("消息盒子信息"),
              ]),
              _c(
                "div",
                { staticClass: "section-content" },
                [
                  _c(
                    "el-form",
                    { attrs: { "label-width": "120px", size: "small" } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "消息标题" } },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.currentRow.msgBoxTitle)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("el-form-item", { attrs: { label: "备注" } }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.currentRow.remark)),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "消息内容" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.currentRow.msgBoxContent)
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "事件类型" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getEventTypeName(
                                          _vm.currentRow.msgBoxEventType
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "事件响应" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentRow.msgBoxEventBody || "-"
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.currentRow.msgBoxIconUrl ||
                      _vm.currentRow.msgBoxImageUrl
                        ? _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _vm.currentRow.msgBoxIconUrl
                                ? _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "icon" } },
                                        [
                                          _c("el-image", {
                                            staticStyle: {
                                              width: "80px",
                                              height: "80px",
                                            },
                                            attrs: {
                                              src: _vm.currentRow.msgBoxIconUrl,
                                              fit: "scale-down",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.currentRow.msgBoxImageUrl
                                ? _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "图片" } },
                                        [
                                          _c("el-image", {
                                            staticStyle: {
                                              width: "80px",
                                              height: "80px",
                                            },
                                            attrs: {
                                              src: _vm.currentRow
                                                .msgBoxImageUrl,
                                              fit: "scale-down",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
        _c("div", { staticClass: "section" }, [
          _c("div", { staticClass: "section-title" }, [_vm._v("命中配置")]),
          _c(
            "div",
            { staticClass: "section-content" },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "120px", size: "small" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("el-form-item", { attrs: { label: "触发条件" } }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.getTriggerConditionName(
                                    _vm.currentRow.activeMode
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _vm.currentRow.daysAhead ||
                      _vm.currentRow.expireAdvanceDays
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "提前天数" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentRow.daysAhead ||
                                          _vm.currentRow.expireAdvanceDays
                                      ) + " 天"
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("el-form-item", { attrs: { label: "用户类型" } }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.getAudienceTypeName(
                                    _vm.currentRow.audienceType
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.currentRow.userTags
                    ? _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "用户标签" } },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.currentRow.userTags)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.currentRow.accountImportKey
                    ? _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "指定账号" } },
                                [_c("span", [_vm._v("已导入文件")])]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.currentRow.audienceType === 4
                    ? _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "客户端" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentRow.isAllPlatform === 1
                                          ? "全部端"
                                          : "指定端"
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.currentRow.platformType &&
                  _vm.currentRow.isAllPlatform === 0
                    ? _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "指定端" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getPlatformTypeNames(
                                          _vm.currentRow.platformType
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.currentRow.onceJobApplyTime
                    ? _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "发送时间" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.currentRow.onceJobApplyTime)
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.currentRow.periodJobStartTime ||
                  _vm.currentRow.periodJobEndTime
                    ? _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _vm.currentRow.periodJobStartTime
                            ? _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "开始时间" } },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentRow.periodJobStartTime
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.currentRow.periodJobEndTime
                            ? _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "结束时间" } },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentRow.periodJobEndTime
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "section" }, [
          _c("div", { staticClass: "section-title" }, [_vm._v("发送配置")]),
          _c(
            "div",
            { staticClass: "section-content" },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "120px", size: "small" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("el-form-item", { attrs: { label: "状态" } }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.currentRow.status === 1 ? "上架" : "下架"
                                )
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "audit-opinion" },
        [
          _c(
            "el-form",
            {
              ref: "auditForm",
              attrs: {
                model: _vm.auditForm,
                rules: _vm.auditRules,
                "label-width": "120px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "审核意见", prop: "content" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "请填写审核意见",
                      maxlength: "500",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.auditForm.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.auditForm, "content", $$v)
                      },
                      expression: "auditForm.content",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleCancel } }, [
            _vm._v("取消"),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "danger", loading: _vm.submitting },
              on: { click: _vm.handleReject },
            },
            [_vm._v("审核不通过")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "success", loading: _vm.submitting },
              on: { click: _vm.handleApprove },
            },
            [_vm._v("审核通过")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }